import { DOMAIN_TYPE } from '../constants';

const DOMAIN_NAME = 'app';

export const START_INITIALIZE =
  `${DOMAIN_TYPE}/${DOMAIN_NAME}/START_INITIALIZE` as const;
